import { Component, NgModule } from '@angular/core';
import { ProxyService } from '../../service/proxy.service';
import { iBisViewComponent } from '@dohu/ibis-common';
import { UploadExcelService } from './upload-excel/upload-excel.service';
@Component({
    selector: 'app-routes',
    templateUrl: './routes.component.html',
    styleUrls: ['./routes.component.scss']
})
export class RoutesComponent extends iBisViewComponent {
    public declare edit: UploadExcelService;
    constructor(public proxy: ProxyService) {
        super(proxy.uploadExcel, proxy.lg, proxy.iui, proxy.activatedRoute);
        this.key = '[MDS]Routes';
    }


    onRouteExpanding(event: any) {
        event.component.collapseAll(-1);
    }

    checkThis(r) {
        console.log(r);
    }

    public toolbarPreparing(event: any) {
        super.toolbarPreparing(event, false);
        event.toolbarOptions.items.push({
            widget: 'dxButton',
            location: 'after',
            options: {
                icon: 'file',
                text: 'Incarca fisier',
                onClick: (ev: any) => {
                    this.edit.showPopup(null, false)
                }
            }
        });
    }
}

